import React from 'react';

import { StyledForm, Row } from './styledComponents';
import ManageSubscriptionButton from 'containers/ManageSubscriptionButton';

/**
 *
 * BillingForm
 *
 * The account page's billing tab. Not a form despite the name and the folder —
 * it collects nothing, because everything it offers happens in the Stripe
 * Customer Portal. It keeps the tab's shape and spacing (StyledForm/Row) so the
 * account page reads as one surface, and it lives here rather than only on the
 * trial countdown banner because billing is where someone would go looking for
 * it — including the customers who never see that banner.
 *
 * The list below is written from the portal configuration actually enabled on
 * the live Stripe account (payment method, cancel at period end, invoice
 * history) rather than from the portal's full feature set, so it does not
 * promise a customer something the portal will not show them.
 */
const BillingForm = () => (
  <StyledForm as="div">
    <Row>
      <p className="text-sm text-gray-700 mb-3">
        Manage your subscription through Stripe, our payment provider. Your card
        details are handled entirely by Stripe and are never stored by
        Movebooth.
      </p>
      <ul className="text-gray-600 text-sm list-disc list-inside space-y-1">
        <li>Add or update your payment method</li>
        <li>View and download past invoices</li>
        <li>Cancel your subscription — it stays active until the end of the period you&apos;ve paid for</li>
      </ul>
    </Row>

    <Row>
      <ManageSubscriptionButton className="px-6 py-2 bg-pink-600 text-white text-sm font-semibold rounded disabled:opacity-40 disabled:cursor-not-allowed hover:bg-pink-700 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-600 transition-colors" />
      <p className="mt-2 text-xs text-gray-500">
        Opens Stripe in this tab. You&apos;ll come straight back when you&apos;re done.
      </p>
    </Row>
  </StyledForm>
);

export default BillingForm;
